import React, { useState, useContext } from 'react'
import '../Login/Login.css'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import { LOGO, SITE_NAME } from '@/utils/UI'
import ForgetComponent from './forgetComponent'
import Loaders from '@/product/components/molecules/Loaders'
import AlertContext from '@/product/context/alert/alertContext'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'

//forgetpassword page
const ForgotPassword = (props) => {
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)

    const validationArray = Yup.object({
        email: Yup.string().email('invalid email format').required('Required'),
    })

    const initialValues = {
        email: '',
    }
    const forgotValues = [
        {
            label: 'Email address',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email address',
            class: 'col-12',
            autoFocus: true,
        },
    ]

    const alertMessage = (data) => {
        if (props?.onSuccess && data?.status === 'success') {
            setAlert(
                data?.message || 'Something went wrong!',
                data?.status || 'error'
            )
            handleRedirectInternal(history, '')
        } else if (props?.onError && data?.status) {
            if (data?.message === 'Email did not match with record') {
                setAlert(
                    'Email did not match with record, contact at mnsurplus.auctions@state.mn.us',
                    data?.status || 'error'
                )
            } else {
                setAlert(
                    data?.message || 'Something went wrong!',
                    data?.status || 'error'
                )
            }
        }
    }

    return (
        <div className="login">
            {isLoading ? (
                <Loaders name="banner" isLoading={isLoading} />
            ) : (
                <div className="loginCnt">
                    <div className="row">
                        <div className="loginLogo">
                            <img src={LOGO} alt={SITE_NAME} />
                        </div>
                        <div className="col-12 loginTitle">
                            <h2>
                                Enter your email address to receive a link to
                                reset your password.
                            </h2>
                        </div>

                        <ForgetComponent
                            validationArray={validationArray}
                            initialValues={initialValues}
                            forgotValues={forgotValues}
                            onSuccess={alertMessage}
                            onError={alertMessage}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
export default ForgotPassword
